
export const environment = {
    version: '1.0.23',
    production: false,
    serviceWorkerEnabled: true,
    updateCheckInterval: 10 * 60 * 1000, // 10 minutes

    apiUrl: 'https://dev.api.americandronenetwork.com',
    webSocketUrl: 'wss://stg.api.americandronenetwork.com',

    appCDN: 'https://dev.cdn.americandronenetwork.com',
    // Brand assets (logos). Same host in every environment.
    staticCDN: 'https://static-cdn.americandronenetwork.com',

    firebase: {
        apiKey: "AIzaSyBOfGg74w6N9HB3dSDlhOuJWT7nAOh1ZX0",
        authDomain: "american-drone-network-dev.firebaseapp.com",
        projectId: "american-drone-network-dev",
        storageBucket: "american-drone-network-dev.firebasestorage.app",
        messagingSenderId: "554938733533",
        appId: "1:554938733533:web:7f0e9206596f3758859c34",
        measurementId: "G-8TM77D5RBS"
    }
}
